import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
// TODO:Spartacus - // TODO:Spartacus - Variable storeFinderTranslations has been removed and is no longer part of the public API.
import { storeFinderTranslationChunksConfig } from '@spartacus/storefinder/assets';
import { StoreFinderRootModule, STORE_FINDER_FEATURE } from '@spartacus/storefinder/root';

@NgModule({
   declarations: [],
   imports: [StoreFinderRootModule],
   providers: [
      provideConfig(<CmsConfig>{
         featureModules: {
            [STORE_FINDER_FEATURE]: {
               module: async () => import('@spartacus/storefinder').then(m => m.StoreFinderModule),
            },
         },
      }),
      provideConfig(<I18nConfig>{
         i18n: {
            chunks: storeFinderTranslationChunksConfig,
         },
      }),
   ],
})
export class StoreFinderFeatureModule {}
